import { debounce } from './debounce';

export function textBlockHeight() {
    let textBlockContainer = document.querySelector('[data-textBlockContainer]');
    let textBlock = document.querySelector('[data-textBlock]');



    if (textBlockContainer) {
        document.addEventListener("DOMContentLoaded", (event) => {
            function updateHeight() {
                textBlockContainer.style.setProperty('--_blockHeight', `${textBlock.offsetHeight}px`);
            }

            updateHeight();

            let debouncedUpdate = debounce(updateHeight, 300);
            window.addEventListener('resize', evt => debouncedUpdate());
        });


    }
}
